import { render, staticRenderFns } from "./nav-section.vue?vue&type=template&id=53e337c2&"
import script from "./nav-section.vue?vue&type=script&lang=js&"
export * from "./nav-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports